import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/looking-warning.svg'


const _hoisted_1 = {
  id: "modal-not-propagated",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "modalNotPropagated",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "text-start" }
const _hoisted_6 = { class: "d-flex mt-2" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = { class: "w-100 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("p", { class: "w-100 text-start fs-5 fw-600 m-0" }, " Ainda não encontramos o código propagado em seu DNS "),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mb-5" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "waiting-room"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-start" }, " As vezes o processo de propagação pode demorar um pouco. ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "w-100 text-start fs-6 fw-600 m-0" }, "Recomendações:", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Icon, {
                name: "circle-exclamation",
                color: "warning",
                style: {"margin-right":"8px","margin-top":"2px"}
              }),
              _cache[1] || (_cache[1] = _createElementVNode("p", null, [
                _createElementVNode("span", { class: "fw-600" }, "Se você iniciou a validação há mais de 24 horas:"),
                _createTextVNode(" Recomendamos que refaça a validação, "),
                _createElementVNode("br"),
                _createTextVNode("verificando todos os dados. ")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Icon, {
                name: "circle-exclamation",
                color: "warning",
                style: {"margin-right":"8px","margin-top":"2px"}
              }),
              _cache[2] || (_cache[2] = _createElementVNode("p", null, [
                _createElementVNode("span", { class: "fw-600" }, "Se você iniciou a validação há menos de 2 horas:"),
                _createTextVNode(" Pedimos que aguarde mais um pouco. ")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args)))
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("span", null, "Ok. Entendi", -1)
            ]))
          ])
        ])
      ])
    ])
  ]))
}